import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import Icon from '../Icon/Icon';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const languages = [
    { code: 'ukr', label: 'Українська', flag: Icon.uaFlag },
    { code: 'en', label: 'English', flag: Icon.eFlag },
    { code: 'pl', label: 'Polski', flag: Icon.pFlag },
    { code: 'ru', label: 'Русский', alt: 'Підарський триколор', flag: Icon.pidarskiytricolor },
  ];

  const handleLanguageChange = (langCode) => {
    setLanguage(langCode);
    setIsModalOpen(false);
  };

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setIsModalOpen(true)}
        className="lang_btn"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        {language.toUpperCase()}
      </button>

      {isModalOpen && (
        <>
          <div
            style={{
              position: 'absolute',
              top: '150%',
              right: '-20px',
              background: '#F5F5EF',
              padding: '15px',
              border: '2px solid #121113',
              zIndex: 1000,
              borderRadius: '15px',
              minWidth: '120px',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontWeight: 'medium' }}>
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => handleLanguageChange(lang.code)}
                  style={{
                    padding: '8px 12px',
                    background: language === lang.code ? 'transparent' : 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    textAlign: 'left',
                    borderRadius: '4px',
                    width: '100%',
                    fontFamily: 'Montserrat',
                    fontSize: '22px',
                    color: '#121113',
                    fontWeight: '700',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <img
                    src={lang.flag}
                    alt={`${lang.alt || lang.label} flag`}
                    style={{
                      width: '33px',
                      height: 'auto',
                    }}
                  />
                  {lang.label}
                </button>
              ))}
            </div>
          </div>

          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.1)',
              zIndex: 999,
            }}
            onClick={() => setIsModalOpen(false)}
          />
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;